import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
var localeSpecificDefaultsMap = {
    "de-DE": {
        settings: {
            market: "DE",
            language: "de",
            phoneNumber: "+49 221 567 999 11"
        },
        openingTimes: {
            common: {
                always: {
                    open: "08:00",
                    close: "20:00"
                }
            }
        }
    },
    "es-ES": {
        settings: {
            market: "ES",
            language: "es",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    },
    "fr-FR": {
        settings: {
            market: "FR",
            language: "fr",
            phoneNumber: "+33 1 73 79 33 33"
        },
        openingTimes: {
            common: {
                workdays: {
                    open: "09:00",
                    close: "18:00"
                }
            }
        }
    },
    "it-IT": {
        settings: {
            market: "IT",
            language: "it",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    },
    "nl-NL": {
        settings: {
            market: "NL",
            language: "nl",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    },
    en: {
        settings: {
            market: "ES",
            language: "en",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    }
};
export var getDefaults = function(locale) {
    var localeSpecificDefaults = localeSpecificDefaultsMap[locale];
    var defaults = {
        settings: _object_spread_props(_object_spread({
            isAppMode: false,
            isTwa: false,
            isInternalCall: false,
            isInfolineCall: false,
            isBotCall: false,
            locale: locale,
            market: "DE",
            validMarkets: [
                "DE",
                "FR",
                "ES",
                "NL",
                "IT"
            ],
            validLanguages: [
                "de",
                "fr",
                "es",
                "nl",
                "it"
            ],
            language: "de",
            phoneNumber: "+49 221 567 999 11"
        }, localeSpecificDefaults.settings), {
            featureToggles: {
                waitForResults: true,
                erv: true,
                maintenanceInfo: false,
                showScaMessage: false,
                hideInfoline: true,
                hideInfolineOnIndex: true,
                isLoginActive: true,
                useElasticSearch: false,
                showSurveyOnSuccess: false,
                showMarketPicker: true,
                skipSecondScaCall: true,
                useSavingBadge: false,
                trustElementOnStageImage: false,
                useNewDesignFooter: false
            },
            sessionData: {
                securityTokenValue: "",
                isMobileUserAgent: false,
                gtmEnvironment: "live",
                anonymizeIP: true
            }
        }),
        openingTimes: _object_spread({
            common: {
                always: {
                    open: "08:00",
                    close: "20:00"
                }
            },
            exceptions: []
        }, localeSpecificDefaults.openingTimes)
    };
    return defaults;
};
